import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DeviceManualOtaComponent } from './manual-ota.component';

const routes: Routes = [
  {
    path: 'manual-ota',
    data: { name: 'Manual OTA', isTab: true },
    component: DeviceManualOtaComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceManualOtaRoutingModule {}
